<template>
    <div class="grid grid-cols-1 gap-6">
        <div class="flex flex-col bg-white rounded-sm shadow">
            <div class="px-4 pt-4">
                <div class="inline-flex">
                    <select
                        v-model="selectedCategory"
                        class="form-select block w-48 pl-3 pr-9 py-2 rounded-l-md rounded-r-none border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 focus:z-10 focus:outline-none focus:shadow-none focus:border-gray-300"
                        @change="applySelectedDataset"
                    >
                        <option value="tickets">{{ $t('Tickets') }}</option>
                        <option v-if="canSeePositionsDataset" value="positions">{{ $t('Positions') }}</option>
                    </select>
                    <select
                        v-model="selectedYear"
                        class="-ml-px block form-select w-32 pl-3 pr-9 py-2 rounded-l-none rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 focus:z-10 focus:outline-none focus:shadow-none focus:border-gray-300"
                        @change="getData"
                    >
                        <option value="current">{{ $t('Current') }}</option>
                        <option v-for="year in availableYears" :key="'year-option-' + year" :value="String(year)">
                            {{ year }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="p-4">
                <loading :status="loading"/>
                <line-chart ref="chart" :chart-data="chartData" :height="350"></line-chart>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from "@/components/charts/line-chart";
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "opened-tickets",
    components: {LineChart},
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        canSeePositionsDataset() {
            return !!this.accessContext.modules.positions;
        },
    },
    data() {
        return {
            loading: true,
            selectedCategory: 'tickets',
            selectedYear: 'current',
            availableYears: [],
            sourceData: {
                tickets: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                positions: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            chartData: {
                labels: this.defaultLabels(),
                datasets: [
                    {
                        label: this.$i18n.t('Tickets'),
                        borderColor: 'rgba(115, 115, 115, 0.75)',
                        backgroundColor: 'rgba(115, 115, 115, 0.07)',
                        pointBackgroundColor: 'rgba(115, 115, 115, 0.75)',
                        pointBorderColor: 'rgba(115, 115, 115, 0.75)',
                        pointRadius: 2,
                        pointHoverRadius: 3,
                        fill: true,
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        defaultLabels() {
            return [
                this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'), this.$t('May'), this.$t('Jun'),
                this.$t('Jul'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec')
            ];
        },
        getData() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/stats/opened-tickets', {
                params: {
                    year: self.selectedYear,
                }
            }).then(function (response) {
                const tickets = Array.isArray(response.data && response.data.tickets) ? response.data.tickets : [];
                const positions = Array.isArray(response.data && response.data.positions) ? response.data.positions : [];
                const labels = Array.isArray(response.data && response.data.labels) ? response.data.labels : [];
                const years = Array.isArray(response.data && response.data.years) ? response.data.years : [];
                self.availableYears = years;
                if (response.data && response.data.year) {
                    self.selectedYear = String(response.data.year);
                }
                self.chartData.labels = labels.length === 12 ? labels : self.defaultLabels();
                self.sourceData.tickets = tickets.length === 12 ? tickets : self.sourceData.tickets;
                self.sourceData.positions = positions.length === 12 ? positions : self.sourceData.positions;
                self.applySelectedDataset();
                self.loading = false;

                self.$nextTick(function () {
                    if (self.$refs.chart) {
                        self.$refs.chart.update();
                    }
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        applySelectedDataset() {
            const dataset = this.chartData.datasets[0];
            if (this.selectedCategory === 'positions' && !this.canSeePositionsDataset) {
                this.selectedCategory = 'tickets';
            }
            if (this.selectedCategory === 'positions') {
                dataset.label = this.$i18n.t('Positions');
                dataset.borderColor = 'rgba(115, 115, 115, 0.75)';
                dataset.backgroundColor = 'rgba(115, 115, 115, 0.07)';
                dataset.pointBackgroundColor = 'rgba(115, 115, 115, 0.75)';
                dataset.pointBorderColor = 'rgba(115, 115, 115, 0.75)';
                dataset.fill = true;
                dataset.data = this.sourceData.positions;
                this.$nextTick(() => {
                    if (this.$refs.chart) {
                        this.$refs.chart.update();
                    }
                });
                return;
            }

            dataset.label = this.$i18n.t('Tickets');
            dataset.borderColor = 'rgba(115, 115, 115, 0.75)';
            dataset.backgroundColor = 'rgba(115, 115, 115, 0.07)';
            dataset.pointBackgroundColor = 'rgba(115, 115, 115, 0.75)';
            dataset.pointBorderColor = 'rgba(115, 115, 115, 0.75)';
            dataset.fill = true;
            dataset.data = this.sourceData.tickets;
            this.$nextTick(() => {
                if (this.$refs.chart) {
                    this.$refs.chart.update();
                }
            });
        }
    },
}
</script>
